import React from 'react';
import { Alert } from '@material-ui/lab';
import { Slide, Snackbar } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import {
  messageSelector,
  messageUpdated
} from '../../redux/features/app/appSlice';

const SlideTransition = (props) => {
  return <Slide {...props} direction="left" />;
};
export const Severity = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info'
};

const Message = () => {
  const dispatch = useDispatch();
  const { text, severity } = useSelector(messageSelector);
  const open = !!text && !!severity;
  return (
    severity &&
    text && (
      <Snackbar
        open={open}
        autoHideDuration={6000}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        onClose={() => {
          dispatch(messageUpdated({ text: '', severity: '' }));
        }}
        TransitionComponent={SlideTransition}>
        <Alert
          data-test="general-message-app"
          elevation={4}
          severity={severity}>
          {text}
        </Alert>
      </Snackbar>
    )
  );
};

export default Message;
